import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import {
 
  Button,
  Checkbox,
  Collapse,
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  Stack,

  Typography,
} from "@mui/material";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import FilterComp from "../../newComponent/iconsComp/FilterComp";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import ResetFilterButton from "../../newComponent/NewButtonComp/ResetFilterButton";
import ApplyFilterButton from "../../newComponent/NewButtonComp/ApplyFilterButton";
export default function({onApplyFilter,onResetFilter}) {
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [open, setOpen] = useState(false);
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [createdbylist, setCreatedbylist] = useState([]);
  const [createdby, setCreatedby] = useState([]);
  const [packageslist, setPackagesList] = useState([]);
  const [packagename, setpackagename] = useState([]);
  const [createfrom, setCreatedfrom] = useState("");
  const [createdto, setCreatedto] = useState("");
  const handleToggle = () => {
    setOpen(!open);
  };

  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  console.log("number",number)
  const handleNamechange = (e) => {
    setName(e.target.value);
  };

  const handleMobileChange = (e) => {
    setNumber(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();

          setBranchlist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allbranchList=[{branch_name:"Select All"},...branchlist]

  const handelbranchchange = (event,value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getallactiveandinactiveuser`);
        if (response.ok) {
          const data = await response.json();
          setCreatedbylist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allleadownerList = [{ first_name: "Select All" }, ...createdbylist];

  const handelcretedby = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setCreatedby(createdbylist);
    } else {
      setCreatedby(value);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}package`);
        if (response.ok) {
          const data = await response.json();
          setPackagesList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allPackageList=[{package_name:"Select All"},...packageslist]
  
  const handelpackagechange = (event,value) => {
 

    if (value.some((option) => option.package_name === "Select All")) {
      setpackagename(packageslist);
    } else {
      setpackagename(value);
    }
   
  };


  const handlecratedfrom = (e) => {
    setCreatedfrom(e.target.value);
  };

  const handlecreatedto = (e) => {
    setCreatedto(e.target.value);
  };

  const newBranch=branch.map((i)=>i.id)
 const newPackageName=packagename.map((i)=>i.id)
 const newCreatedBy =createdby.map((i=>i.id))
  const handleApplyFilter = () => {
    onApplyFilter({
    name,
  number,
  newCreatedBy,createfrom, createdto,
newBranch,newPackageName

    });

  };

  const resetfilter = () => {
    onResetFilter();
    setName("")
    setNumber("")
   setCreatedby([])
   setCreatedfrom("")
   setCreatedto("")
   setBranch([])
   setpackagename([])
   
   
  }
  return (
    <div>
      <MainCard>
        <Stack
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="h3"
          >
            Update Future Enrollments
          </Typography>

      <FilterComp onClick={handleToggle} fontSize="medium" />
        </Stack>
        <Collapse in={open} sx={{ marginTop: open? "10px"  :0}}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={3} md={6} sm={6}>
              <Typography variant="h6">Enquiry Name </Typography>
              <CustomTextFieldComp
              size="normal"
                value={name}
                onChange={handleNamechange}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} lg={3} md={6} sm={6}>
              <Typography variant="h6">Mobile Number </Typography>
              <CustomTextFieldComp
                    size="normal"
                value={number}
                onChange={handleMobileChange}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                fullWidth
                type="number"
              />
            </Grid>

            <Grid item xs={12} lg={3} md={6} sm={6}>
           
           <Typography variant="h6">Branch</Typography>

          
     
     <CustomAutocompleteComp
           size="normal"
           fullWidth
           value={branch}
           multiple
           onChange={handelbranchchange}
           options={allbranchList}
           getOptionLabel={(option) =>
            option.branch_name
           }
          tooltipContent={(option) =>
            option.branch_name
           }
         />
       </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
           
                <Typography variant="h6">Created By</Typography>
             
            
  <CustomAutocompleteComp
                size="normal"
                value={createdby}
                multiple
                onChange={handelcretedby}
                options={allleadownerList}
                getOptionLabel={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
               tooltipContent={(option) =>
                `${option.first_name ? option.first_name : ""} ${
                  option.last_name ? option.last_name : ""
                }`
              }
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
           
                <Typography variant="h6">
                  Package Details
                </Typography>
                {/* <Select
                  multiple
                  value={packagename}
                  onChange={handelpackagechange}
                  fullWidth
                  MenuProps={MenuProps}
                  style={{ borderRadius: "10px" }}
                  renderValue={(selected) =>
                    selected
                      .map((value) => {
                        if (value === "all") return "Select All";
                        const packages = packageslist.find(
                          (status) => status.id === value
                        );
                        return packages ? packages?.package_name : "";
                      })
                      .join(", ")
                  }
                >
                  <MenuItem key="select-all" value="all">
                    <Checkbox
                      checked={packagename.length === packageslist.length}
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {packageslist.map((name) => (
                    <MenuItem key={name.id} value={name.id}>
                      <Checkbox checked={packagename.indexOf(name.id) > -1} />
                      <ListItemText primary={name.package_name} />
                    </MenuItem>
                  ))}
                </Select> */}
      
      <CustomAutocompleteComp
                size="normal"
                value={packagename}
                multiple
                onChange={handelpackagechange}
                options={allPackageList}
                getOptionLabel={(option) =>
                 option.package_name
                }
                tooltipContent={(option) =>
                  option.package_name
                 }
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6"> Created From Date </Typography>
              <CustomTextFieldComp
                    size="normal"
                value={createfrom}
                onChange={handlecratedfrom}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                fullWidth
                type="date"
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Created To Date </Typography>
              <CustomTextFieldComp
                    size="normal"
                value={createdto}
                onChange={handlecreatedto}
                InputProps={{
                  style: { borderRadius: "10px" },
                }}
                fullWidth
                type="date"
              />
            </Grid>

            <Grid item xs={12} lg={12} sm={12} md={12}  container  justifyContent="end" gap={1}>
            <ApplyFilterButton
               
               onClick={handleApplyFilter}
            />
            
              <ResetFilterButton
                
                 onClick={resetfilter}
              />
            

       
            </Grid>
          </Grid>
        </Collapse>
      </MainCard>
    </div>
  );
}
